/*
 * Honey & Paw motion: scroll reveal + add-to-cart feedback.
 * Progressive enhancement: if this never runs, everything is fully visible.
 * Fully disabled for visitors who prefer reduced motion.
 */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) return;

  // 1) Reveal sections as they scroll into view (only hides the ones below the fold).
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('hp-reveal--in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    var vh = window.innerHeight || document.documentElement.clientHeight;
    var sections = document.querySelectorAll('#MainContent .shopify-section');
    sections.forEach(function (section) {
      if (section.getBoundingClientRect().top > vh * 0.85) {
        section.classList.add('hp-reveal--init');
        io.observe(section);
      }
    });
  }

  // 2) Bounce the cart count bubble whenever the cart changes.
  function watchCart() {
    var host = document.querySelector('#cart-icon-bubble') || document.querySelector('.header__icon--cart');
    if (!host) return;
    var observer = new MutationObserver(function () {
      var bubble = host.querySelector('.cart-count-bubble');
      if (!bubble) return;
      bubble.classList.remove('hp-bump');
      void bubble.offsetWidth; // restart the animation
      bubble.classList.add('hp-bump');
    });
    observer.observe(host, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState !== 'loading') watchCart();
  else document.addEventListener('DOMContentLoaded', watchCart);

  // 3) Count-up stat numbers when they scroll into view
  function runCount(el) {
    var full = (el.textContent || '').trim();
    var m = full.match(/([\d][\d.,]*)/);
    if (!m) return;
    var raw = m[1];
    var target = parseFloat(raw.replace(/,/g, ''));
    if (isNaN(target)) return;
    var decimals = (raw.split('.')[1] || '').length;
    // Don't count-up decimal values: a rating like 4.8 would flash misleading 2.7 / 3.6
    // on its way up. Leave it at its final value (integers like 12,000 and 30 still animate).
    if (decimals > 0) return;
    var grouped = raw.indexOf(',') > -1;
    var prefix = full.slice(0, m.index);
    var suffix = full.slice(m.index + raw.length);
    var startTs = null;
    var dur = 1100;
    function fmt(v) {
      var s = decimals ? v.toFixed(decimals) : (grouped ? Math.round(v).toLocaleString('en-US') : String(Math.round(v)));
      return prefix + s + suffix;
    }
    function step(ts) {
      if (!startTs) startTs = ts;
      var p = Math.min((ts - startTs) / dur, 1);
      el.textContent = fmt(target * (1 - Math.pow(1 - p, 3)));
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = full;
    }
    requestAnimationFrame(step);
  }
  if ('IntersectionObserver' in window) {
    var cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { runCount(e.target); cio.unobserve(e.target); }
      });
    }, { threshold: 0.4 });
    document.querySelectorAll('[data-countup]').forEach(function (el) { cio.observe(el); });
  }
})();
